"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _Countdown = require("./Countdown.style");

var CountdownBody = function CountdownBody(_ref) {
  var title = _ref.title,
      cta = _ref.cta,
      variant = _ref.variant,
      timerComponents = _ref.timerComponents,
      expiredMsg = _ref.expiredMsg;

  // Checks if all values (days, hours, etc) are equal to zero
  var hasTimedOut = function hasTimedOut(components) {
    if (components.every(function (_ref2) {
      var time = _ref2.props.time;
      return time === '0';
    })) {
      return false;
    }

    return true;
  };

  return /*#__PURE__*/_react.default.createElement(_Countdown.CountdownWrapper, {
    variant: variant
  }, title && /*#__PURE__*/_react.default.createElement(_Countdown.CountdownTitle, {
    size: "xlarge",
    variantType: variant
  }, title), /*#__PURE__*/_react.default.createElement(_Countdown.CountdownBlock, {
    variantType: variant
  }, hasTimedOut(timerComponents) ? timerComponents : /*#__PURE__*/_react.default.createElement("span", null, expiredMsg)), cta.url && cta.label && /*#__PURE__*/_react.default.createElement(_Button.default, {
    url: cta.url
  }, cta.label));
};

CountdownBody.propTypes = {
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }).isRequired,
  timerComponents: _propTypes.default.arrayOf(_propTypes.default.element),
  title: _propTypes.default.string,
  expiredMsg: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['fixed', 'regular', 'light'])
};
CountdownBody.defaultProps = {
  timerComponents: [],
  title: '',
  expiredMsg: '',
  variant: 'regular'
};
var _default = CountdownBody;
exports.default = _default;